// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function () {
	/*
	Swurvey Services
	*/
	"use strict";

	angular.module("swurveys.common")
		.factory("swurveyService", Handler)

	function Handler(utilsService, $q, $http, swurveysStageConfig) {

		var API_URI = swurveysStageConfig.getConfigPropertyValue("api_endpoint") + "/api/swurveys/";
		var swurveStartTime = Date.now();

		console.log('computed api', API_URI);

		var getModel = function (swurveyId, callback) {
			$http.get(TEST_API || (API_URI + swurveyId + "/model"))
				.then(function (response) {
					if(response.data.errorType) {
						return callback(response.data);
					}

					return callback(null, response);
				}, callback);
		};

		var userToken;

		var postResponse = function (swurveyId, state, allCards, swurveyResponse) {
			swurveyResponse.timeMS = Date.now() - swurveStartTime;

			var deferred = $q.defer();

			if(state !== "Published") {

				deferred.resolve({
					percentage: 99,
					answer: "YES",
					question: "<b>Should I Use Swurveys?</b>"
				});

				return deferred.promise;
			}

			return $http.post(API_URI + swurveyId + "/responses", swurveyResponse)
				.then(function (resp) {
					if(resp && resp.data) {
						userToken = resp.data.ResponseId;
						return utilsService.makeFeedback(allCards, resp.data);
					}
				}, function (err) {
					return {
						percentage: 100,
						answer: "Something is Wrong",
						question: "<b>Please Contact us for Support</b>"
					}
					console.error(err);
				});
		};

        var metadata = {};
		var attachMetadata = function(swurveyId, md)
		{
			if(Object.assign)
			{
              //Metadata is not cumulative on the server.
			  //Here, we merge any new metadata to any previously collected in this session
			  //This covers, for example, lead gen + a call to action click 
			  Object.assign(metadata, md );
			}
			$http.post(API_URI + swurveyId + "/responses", { metadata : metadata, userToken : userToken}).then(function(resp){
				console.log("Posted metadata!", resp);
			});
		}

		return {
			postResponse: postResponse,
			attachMetadata : attachMetadata,
			API_URI: API_URI,
			getModel: getModel
		};
	}

}());
